import React from 'react';
import './Styles/stars.css';

class HTMLContent extends React.Component {
  render() {
    return (
      <html lang="en">
        <head>
          <meta charset="UTF-8" />
          <meta http-equiv="X-UA-Compatible" content="IE=edge" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <link rel="stylesheet" href="stars.css" />
          <title>Document</title>
        </head>
        <body>
          <div class="starScreen">
            <div class="main"></div>
          </div>
        </body>
      </html>
    );
  }
}

export default HTMLContent;
